export default "__VITE_ASSET__DjVQnDAh__"